<div class="dashboard-content-sec">
    <div class="card mb-0">
        <div>
            <div class="mr-4 d-inline-block">
                <a id="expand" style="width:140px" data-toggle="collapse" class="p-2 fa fa- gd-alt" 
                    href="#serviceTable" (click)="swapIcon($event)">
                      {{this.total}} Services</a>
            </div>

            <div style='width: 120px' class="d-inline-block">
                <a data-toggle="collapse" href="#newservice" (click)="expandTable()"
                    class="fa fa-address-book btn btn-default ">
                    Add Service
                </a>                        
            </div>       
        </div>
        <div class="table-responsive collapse" id="serviceTable">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table user-table table-striped" >
                <thead>
                    <tr>
                        <th *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                            <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                            <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                            <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i>
                            {{header.text}}
                        </th>
                      <th>Edit/Save</th>
                      <th>Delete/Cancel</th>
                    </tr>

                </thead>

                <tr id="newservice" class="collapse">
                    <td>
                        <a data-toggle="collapse" href="#serviceEdit0">
                            <div>  
                                <select id="code0" (change)="updateDescription($event)">
                                    <option value="{{serv.ID}}" *ngFor="let serv of serviceCodes">
                                        {{serv?.Code}} 
                                    </option>
                                </select>
                            </div>
                        </a>
                    </td>    
        
                    <td>
                        <div id="code0desc">
                            {{firstCodeValue}}
                        </div>
                    </td>    
                              
                    <td>
                        <div class="d-inline-block">
                            <a id='icon0' title="Save" class="btn fa fa-save service" (click)="saveService(0)"></a>
                        </div>
                    </td>
                    <td>
                        <div class="d-inline-block">
                            <a title="Cancel" class="btn fa fa-times" (click)="cancelService(0)"></a>
                        </div>                        
                    </td>
                </tr>

                <tbody>
                    <ng-container *ngFor="let obj of services">
                        <tr>                  
                            <td>
                                <a data-toggle="collapse" href="#serviceEdit{{obj.ID}}">
                                    <div>  
                                        <label id="label{{obj.ID}}">{{obj.code}}</label>
                                        <select style="display:none" id="code{{obj.ID}}" (change)="updateDescription($event)">
                                            <option value="{{serv.ID}}" *ngFor="let serv of serviceCodes"
                                                [selected]="serv.ID == obj.CodeID">
                                                {{serv?.Code}} 
                                            </option>
                                        </select>
                                    </div>

                                </a>
                            </td>    

                            <td>
                                <div id="code{{obj.ID}}desc">
                                    {{obj.description}}
                                </div>
                            </td>    
                        
                            <td>
                                <div class="d-inline-block">
                                    <a id="icon{{obj.ID}}" title="Edit" class="btn fa fa-pencil service" (click)="editService(obj.ID)"></a>
                                </div>
                            </td>
                            <td>
                                <div class="d-inline-block">
                                    <a title="Delete" class="btn fa fa-times" (click)="deleteService(obj.ID)"> </a>
                                </div>
                            </td>
                        </tr>

                    </ng-container>
                </tbody>                
            </table>
            <div *ngIf="this.successful_result"
                class="alert alert-success" role="alert">
                Successfully saved record
            </div>
            <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                Unable to save record. Error occurred.
            </div>

        </div>
    </div>
</div>